import { ValueOf } from 'modules/Monitoring/types'

export const UrlStateStorageKeys = {
  GlobalFilters: 'filters',
  AdditionalFilters: 'additional-filters',
  TicketVolumeControls: 'ticket-volume-controls',
  AgentIntervalAttendanceControls: 'agent-interval-attendance-controls',
  QueueHealthDetailsTableState: 'qhdts',
  TicketVolumeTableState: 'tvts',
  TicketVolumeTableSelectedCharts: 'tvtsc',
  AgentAttendanceDetailsState: 'aads',
  AgentIntervalAttendanceTableState: 'aiats',
  AgentIntervalAttendanceTableSelectedCharts: 'aiatsc',
} as const

export type UrlStateStorageKeys = ValueOf<typeof UrlStateStorageKeys>
